import { isAxiosError } from 'axios';
import { departmentApi } from '@/entities/Department';
import { toastError, toastSuccess, useCustomToast } from '@/shared/lib';

export function useDepartmentPositionManagement() {
  const toast = useCustomToast();

  async function updateDepartmentPositions(
    departmentId: number,
    addPositionIds: number[],
    removePositionIds: number[],
    code?: string
  ): Promise<{ success: boolean }> {
    const safeCode = code !== undefined && code !== '' ? code : undefined;
    const hasChanges =
      safeCode !== undefined || addPositionIds.length > 0 || removePositionIds.length > 0;

    if (!hasChanges) {
      toastSuccess(toast, 'Edições salvas com sucesso');
      return { success: true };
    }

    try {
      await departmentApi.updatePositions(departmentId, {
        code: safeCode,
        addPositionIds,
        removePositionIds,
      });
    } catch (error) {
      if (
        isAxiosError(error) &&
        error.response?.status === 400 &&
        error.response?.data?.message === 'Departamento já existe'
      ) {
        toastError(
          toast,
          'Algumas edições não foram salvas',
          'O código já está sendo usado em outro departamento'
        );
      } else {
        toastError(
          toast,
          'Algumas edições não foram salvas',
          'Erro ao salvar edições do departamento'
        );
      }
      return { success: false };
    }

    toastSuccess(toast, 'Edições salvas com sucesso');

    return { success: true };
  }

  return { updateDepartmentPositions };
}
